/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export * from './embed-empty.component';
export * from './empty.component';
export * from './empty.module';
export * from './config';
export { NzEmptySimpleComponent } from './partial/simple';
export { NzEmptyDefaultComponent } from './partial/default';
